export type SalesDataClientSourceSendTaskPayload = {
  licenseId: number
  monthlyAnalyticsId: number
  notes: string
}
